/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderCheckAddOrUpdateVo
 */
export interface OrderCheckAddOrUpdateVo {
    /**
     * 商品检查单ID, 新增不需要传id，修改需要传
     * @type {number}
     * @memberof OrderCheckAddOrUpdateVo
     */
    id?: number;
    /**
     * 商品ID
     * @type {number}
     * @memberof OrderCheckAddOrUpdateVo
     */
    goodsId?: number;
    /**
     * 商品错误数量
     * @type {number}
     * @memberof OrderCheckAddOrUpdateVo
     */
    goodsErrorQuantity?: number;
    /**
     * 商品错误类型   1 数量有误（未入库） 2 商品破损 3 商品有误 4 剩余产品
     * @type {number}
     * @memberof OrderCheckAddOrUpdateVo
     */
    goodsErrorType?: number;
}

/**
 * Check if a given object implements the OrderCheckAddOrUpdateVo interface.
 */
export function instanceOfOrderCheckAddOrUpdateVo(value: object): value is OrderCheckAddOrUpdateVo {
    return true;
}

export function OrderCheckAddOrUpdateVoFromJSON(json: any): OrderCheckAddOrUpdateVo {
    return OrderCheckAddOrUpdateVoFromJSONTyped(json, false);
}

export function OrderCheckAddOrUpdateVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCheckAddOrUpdateVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'goodsErrorQuantity': json['goodsErrorQuantity'] == null ? undefined : json['goodsErrorQuantity'],
        'goodsErrorType': json['goodsErrorType'] == null ? undefined : json['goodsErrorType'],
    };
}

export function OrderCheckAddOrUpdateVoToJSON(json: any): OrderCheckAddOrUpdateVo {
    return OrderCheckAddOrUpdateVoToJSONTyped(json, false);
}

export function OrderCheckAddOrUpdateVoToJSONTyped(value?: OrderCheckAddOrUpdateVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'goodsId': value['goodsId'],
        'goodsErrorQuantity': value['goodsErrorQuantity'],
        'goodsErrorType': value['goodsErrorType'],
    };
}

